
<style scoped lang="less">

.my_header{
   height: 60px;
   background: #ffffff;
   .header-center{
     width:1200px;
     height: 100%;
     margin:0 auto;
     .logo{
      float: left;
      margin-right: 290px;
      height: 100%;
      a{
        display: inline-block;
        width:138px;
        height: 41px;
        padding-top: 10px;
      }
     }
     .nav{
       float: right;
       li{
         float: left;
         margin-left: 70px;
         line-height: 60px;
         a{
           color:#5f5f5f;
           text-decoration: none;
           padding-bottom: 9px;
         }
       }
     } 
   }
}
.active {
  color: #0a3f89 !important;
  padding-bottom: 6px;
  border-bottom: 2px solid #0a3f89;
}
</style>
<style>
  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
  }
</style>
<template>
  <div class="my_header">
    <div class="header-center">
       <div class="logo">
        
              <router-link to="/Home">
            <img src="../../assets/img/logo.png" alt="">
               </router-link>
       </div>
       <div class="nav">
          <ul class="clearfix">
            <li>
                 <router-link to="/Home" :class="{active:'/Home'===$route.path}">首页</router-link>
            </li>
            <li>
               <router-link
            to="/order"
            :class="{active:'/order'===$route.path||'/order/overbooking'===$route.path||'/order/query'===$route.path||'/order/priceinquiry'===$route.path}"
          >快递服务</router-link>
              
              </li>
            <li>
              <router-link
            to="/service"
            :class="{active:'/service'===$route.path||'/service/transportationrode'===$route.path
    ||'/service/inland'===$route.path||'/service/storage'===$route.path||'/service/packaging'===$route.path
    ||'/service/orderline'===$route.path}"
          >服务中心</router-link>
              </li>
              <li>
                  <router-link
            to="/news"
            :class="{active:'/news'===$route.path||'/news/infos'===$route.path||'/news/newslist'===$route.path.split('t')[0]+'t'}"
          >新闻资讯</router-link>
              </li>
            <li>
               <router-link
            to="/about"
            :class="{active:'/about'===$route.path||'/about/insurance'===$route.path||'/about/motorcade'===$route.path||
            '/about/process'===$route.path||'/about/promise'===$route.path||'/about/synopsis'===$route.path}"
          >关于我们</router-link>
              </li>
            <li>
              <router-link
            to="/contact"
            :class="{active:'/contact'===$route.path||'/contact/call'===$route.path||'/contact/recruit'===$route.path}"
          >联系我们</router-link>
              </li>
          </ul>
       </div>
      <!-- <ul class="clearfix">
        <li class="my_img">
          <router-link to="/Home">
               <img src="../../assets/img/logo.png" alt>
          </router-link>
         
        </li>
        <li class="my_first">
          <router-link to="/Home" :class="{active:'/Home'===$route.path}">首页</router-link>
        </li>
        <li>
          <router-link
            to="/order"
            :class="{active:'/order'===$route.path||'/order/overbooking'===$route.path||'/order/query'===$route.path||'/order/priceinquiry'===$route.path}"
          >快递服务</router-link>
        </li>
        <li>
          <router-link
            to="/service"
            :class="{active:'/service'===$route.path||'/service/transportationrode'===$route.path
    ||'/service/inland'===$route.path||'/service/storage'===$route.path||'/service/packaging'===$route.path
    ||'/service/orderline'===$route.path}"
          >服务中心</router-link>
        </li>
        <li>
          <router-link
            to="/news"
            :class="{active:'/news'===$route.path||'/news/infos'===$route.path||'/news/newslist'===$route.path.split('t')[0]+'t'}"
          >新闻资讯</router-link>
        </li>
        <li>
          <router-link
            to="/about"
            :class="{active:'/about'===$route.path||'/about/insurance'===$route.path||'/about/motorcade'===$route.path||
            '/about/process'===$route.path||'/about/promise'===$route.path||'/about/synopsis'===$route.path}"
          >关于我们</router-link>
        </li>
        <li>
          <router-link
            to="/contact"
            :class="{active:'/contact'===$route.path||'/contact/call'===$route.path||'/contact/recruit'===$route.path}"
          >联系我们</router-link>
        </li>
      </ul> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  }
};
</script>





// WEBPACK FOOTER //
// src/components/Header/Header.vue